module.exports = __webpack_public_path__ + "front/img/83.a902ab85.jpg";